/**
 * Session helpers for the admin console. The authenticated admin user is
 * stored in localStorage under `user`, with the bearer token under
 * `accessToken` (set by useAuthService on login).
 */
export interface AdminUser {
  id: string;
  name: string;
  email: string;
  role: string; // e.g. "Super Admin"
}

export function getUser(): AdminUser | null {
  const raw = localStorage.getItem('user');
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AdminUser;
  } catch {
    return null;
  }
}

export function isAuthenticated(): boolean {
  return !!localStorage.getItem('accessToken');
}

export function getDisplayName(): string {
  return getUser()?.name || 'Super Admin';
}

export function getEmail(): string {
  return getUser()?.email || 'admin@basequeue.com';
}

export function getRoleName(): string {
  return getUser()?.role || 'Super Admin';
}

export function clearSession(): void {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('user');
}

/** Two-letter initials for avatar placeholders. */
export function initials(name: string): string {
  return (name || '?')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}
